var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teacher",
    transform: "translate(-0.381 -0.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31075",
    "data-name": "Path 31075",
    d: "M11.292,16.382a4.057,4.057,0,0,1-2.212-.624l-5.6-3.776a3.853,3.853,0,0,1,0-6.341l5.6-3.766a4.2,4.2,0,0,1,4.424.01L19.081,5.66a3.847,3.847,0,0,1,0,6.322l-5.568,3.776A3.987,3.987,0,0,1,11.292,16.382Zm0-13.691a2.542,2.542,0,0,0-1.441.394l-5.6,3.766a2.377,2.377,0,0,0,0,3.92l5.6,3.776a2.9,2.9,0,0,0,2.9,0l5.568-3.776a2.39,2.39,0,0,0,0-3.92L12.751,3.075A2.765,2.765,0,0,0,11.292,2.691Z",
    transform: "translate(1.562 1.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31076",
    "data-name": "Path 31076",
    d: "M11.75,21.15A4.475,4.475,0,0,1,10.544,21l-3.078-.9a3.568,3.568,0,0,1-2.6-3.166l.01-3.97A.689.689,0,0,1,5.6,12.33a.689.689,0,0,1,.724.635l-.01,3.97A2.321,2.321,0,0,0,7.929,18.9l3.078.9a3.386,3.386,0,0,0,1.486,0l3.078-.9a2.321,2.321,0,0,0,1.611-1.955V13.016a.73.73,0,0,1,1.447,0v3.928a3.59,3.59,0,0,1-2.6,3.166l-3.078.9A4.853,4.853,0,0,1,11.75,21.15Z",
    transform: "translate(1.094 1.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31077",
    "data-name": "Path 31077",
    d: "M21.285,14.6a.639.639,0,0,1-.635-.635V8.885a.635.635,0,1,1,1.27,0v5.079A.639.639,0,0,1,21.285,14.6Z",
    transform: "translate(0.361 1.476)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8665",
    "data-name": "Rectangle 8665",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHat);
export default __webpack_public_path__ + "static/media/menu-hat.02e4c27d19b6dbe9020c0c98aad55173.svg";
export { ForwardRef as ReactComponent };